import { FormState } from 'final-form'
import React, { useRef } from 'react'
import { FormSpy } from 'react-final-form'

type TOnChange = {
  preventFireOnMount?: boolean
  onChange?: (formState: FormState<Record<string, any>>) => void
}

const OnChange = (props: TOnChange): React.ReactElement => {
  const { preventFireOnMount } = props

  const refInit = useRef<boolean>()

  const onChange = (values: FormState<Record<string, any>>): void => {
    if (!refInit.current) {
      refInit.current = true
      if (preventFireOnMount) {
        return
      }
    }
    if (props.onChange) {
      props.onChange(values)
    }
  }

  return <FormSpy subscription={{ values: true }} onChange={onChange} />
}

export default OnChange
